import store from '@src/store';
import { REFETCH_CUSTOMER_DATA } from '@src/app/login/weak/actions';

export const SUSPEND_START = 'SUSPEND_START';
export const SUSPEND_SUCCESS = 'SUSPEND_SUCCESS';
export const SUSPEND_ERROR = 'SUSPEND_ERROR';
export const SUSPEND_LOADING = 'SUSPEND_LOADING';
export const SUSPEND_CANCEL = 'SUSPEND_CANCEL';
export const GET_ISSUES_START = 'GET_ISSUES_START';
export const GET_ISSUES_SUCCESS = 'GET_ISSUES_SUCCESS';
export const GET_ISSUES_ERROR = 'GET_ISSUES_ERROR';
export const GET_ISSUES_LOADING = 'GET_ISSUES_LOADING';

export type Actions = {
  SUSPEND_START: { type: typeof SUSPEND_START; payload: boolean };
  SUSPEND_LOADING: { type: typeof SUSPEND_LOADING; payload: boolean };
  SUSPEND_SUCCESS: { type: typeof SUSPEND_SUCCESS; payload: any };
  SUSPEND_ERROR: { type: typeof SUSPEND_ERROR; payload: any };
  SUSPEND_CANCEL: { type: typeof SUSPEND_CANCEL; payload: any };
  GET_ISSUES_START: { type: typeof GET_ISSUES_START; payload: {magCode: string, accountNumber: string, lastIssue: string} };
  GET_ISSUES_LOADING: { type: typeof GET_ISSUES_LOADING; payload: boolean };
  GET_ISSUES_SUCCESS: { type: typeof GET_ISSUES_SUCCESS; payload: any };
  GET_ISSUES_ERROR: { type: typeof GET_ISSUES_ERROR; payload: any };
};
// Action Creators
export const actionCreators = {
  suspendStart: (payload: any): Actions[typeof SUSPEND_START] => ({
    type: SUSPEND_START,
    payload,
  }),
  suspendError: (payload: any): Actions[typeof SUSPEND_ERROR] => ({
    type: SUSPEND_ERROR,
    payload,
  }),
  suspendSuccess: (payload: any): Actions[typeof SUSPEND_SUCCESS] => {
   // store.dispatch({type: REFETCH_CUSTOMER_DATA, payload: payload.refetchCustomerPayload});
    return ({ type: SUSPEND_SUCCESS, payload: payload});
  }
  ,
  suspendLoading: (payload: boolean): Actions[typeof SUSPEND_LOADING] => ({
    type: SUSPEND_LOADING,
    payload,
  }),
  suspendCancel: (payload: boolean): Actions[typeof SUSPEND_CANCEL] => ({
    type: SUSPEND_CANCEL,
    payload,
  }),

  getIssuesStart: (payload: any): Actions[typeof GET_ISSUES_START] => ({
    type: GET_ISSUES_START,
    payload,
  }),
  getIssuesError: (payload: any): Actions[typeof GET_ISSUES_ERROR] => ({
    type: GET_ISSUES_ERROR,
    payload,
  }),
  getIssuesSuccess: (payload: any): Actions[typeof GET_ISSUES_SUCCESS] => ({
    type: GET_ISSUES_SUCCESS,
    payload,
  }),
  getIssuesLoading: (payload: boolean): Actions[typeof GET_ISSUES_LOADING] => ({
    type: GET_ISSUES_LOADING,
    payload,
  }),
};
